module.exports = __webpack_public_path__ + "media/customizations/wolfranchlife/logo-new-f7ceb88a352239633c7f812acdd52510.png";